/**
 * GENERATED FILE — DO NOT EDIT BY HAND.
 *
 * Written by scripts/sync-statutory.js from the mothership's authoritative
 * company record, which is the only place these values are maintained:
 *   https://api.axoix.in/api/public/company-settings
 *
 * Fetched: 2026-10-19T09:16:23.938Z
 *
 * Edit nothing here. To change a value, change it on the mothership and
 * re-run `node scripts/sync-statutory.js` (prebuild does this automatically).
 * Hand-written helpers and anything this endpoint does not serve live in
 * ./statutoryIdentifiers.ts alongside it.
 */

export const GENERATED_AT = "2026-10-19T09:16:23.938Z";
export const GENERATED_FROM = "https://api.axoix.in/api/public/company-settings";

export const MOTHERSHIP_LEGAL = {
  legalName: "AXOIX TECHNOLOGIES PRIVATE LIMITED",
  cin: "U62099DC2026PTC471359",
  udyam: "UDYAM-DL-10-0120748",
  duns: "581637158",
  dpiit: "DIPP270090",
  registeredOffice: "B-59, Second Floor, Southern Side, Block B, Rama Park Road, Uttam Nagar, New Delhi - 110059",
} as const;
